import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {Tile} from "@/modules/redactor/models/utils/Tile";

export class Swamp extends BaseObject {

    constructor() {
        super();

        this._id = 0;
        this._width = 0;
        this._height = 0;
        this._pathLength = 0;
        this._bottomLeftTile = null;
        this._topRightTile = null;
        this._pathItem = null;
        this._blockItem = null;
        this._heroItem = null;
        this._heroTeleportTile = null;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get width() {
        return this._width;
    }

    set width(value) {
        this._width = value;
    }

    get height() {
        return this._height;
    }

    set height(value) {
        this._height = value;
    }

    get pathLength() {
        return this._pathLength;
    }

    set pathLength(value) {
        this._pathLength = value;
    }

    get bottomLeftTile() {
        return this._bottomLeftTile;
    }

    set bottomLeftTile(value) {
        this._bottomLeftTile = value;
    }

    get topRightTile() {
        return this._topRightTile;
    }

    set topRightTile(value) {
        this._topRightTile = value;
    }

    get pathItem() {
        return this._pathItem;
    }

    set pathItem(value) {
        this._pathItem = value;
    }

    get blockItem() {
        return this._blockItem;
    }

    set blockItem(value) {
        this._blockItem = value;
    }

    get heroItem() {
        return this._heroItem;
    }

    set heroItem(value) {
        this._heroItem = value;
    }

    get heroTeleportTile() {
        return this._heroTeleportTile;
    }

    set heroTeleportTile(value) {
        this._heroTeleportTile = value;
    }

    valid() {

        if (!Number.isInteger(this.id) || this.id < 0) {
            return false;
        }

        if (!Number.isInteger(this.width) || this.width <= 0) {
            return false;
        }

        if (!Number.isInteger(this.height) || this.height <= 0) {
            return false;
        }

        if (!Number.isInteger(this.pathLength) || this.pathLength <= 0) {
            return false;
        }

        // Maximal path length validation
        const maxPathLength = (this.height % 2 === 0)
            ? ((this.width + 1) * (this.height - 2)) / 2 + 2
            : ((this.width + 1) * (this.height - 1)) / 2 + 1;
        if (this.pathLength > maxPathLength) {
            return false;
        }

        // Validate pathItem and blockItem ItemGroup
        if (!this.pathItem) {
            return false;
        }
        if (!this.blockItem) {
            return false;
        }

        if(this.pathItem.level > 0 || this.blockItem.level > 0) {
            return false;
        }

        if (!this.heroItem) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Swamp());
        } else if (target instanceof Swamp) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Swamp, {
    _id: alias("id", Schema.primitive()),
    _width: alias("width", Schema.primitive()),
    _height: alias("height", Schema.primitive()),
    _pathLength: alias("path_length", Schema.primitive()),

    _bottomLeftTile: alias("bottom_left_tile", Tile.schema()),
    _topRightTile: alias("top_right_tile", Tile.schema()),

    _pathItem: alias("path_item", ItemKey.schema()),
    _blockItem: alias("block_item", ItemKey.schema()),

    _heroItem: alias("hero_item", ItemKey.schema()),
    _heroTeleportTile: alias("hero_teleport_tile", Tile.schema()),
});